module.exports = __webpack_public_path__ + "static/media/info-triangle-red.83640a07.svg";